import { RadioBullet } from 'components/RadioGroup/RadioBullet'
import Styles from './SubjectLineSelection.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { TextFieldLoadingState } from 'components/Wizards/TextFieldLoadingState/TextFieldLoadingState'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import cx from 'classnames'

const OptionStub = ({ position }: { position: number }) => {
  const { isMobile } = useResponsiveDesign()

  return (
    <div className={Styles.optionStub}>
      <div />
      <div className={cx(Styles.inputLabel, Styles.loading)}>
        <Text variant="secondary" color={isMobile ? 'var(--dark-60)' : 'var(--dark-40)'}>
          Subject Line #{position}
        </Text>
      </div>
      <RadioBullet size={20} isDisabled />
      <TextFieldLoadingState />
    </div>
  )
}

export const SubjectLineLoadingState = ({ startPosition = 1 }: { startPosition?: number }) => (
  <div className={Styles.optionStubs}>
    <OptionStub position={startPosition} />
    <OptionStub position={startPosition + 1} />
    <OptionStub position={startPosition + 2} />
    <OptionStub position={startPosition + 3} />
    <OptionStub position={startPosition + 4} />
  </div>
)
